// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"MaterialDetailImage_imageWrapper__TfjjE","zoomButton":"MaterialDetailImage_zoomButton__dswh0"};